import React from "react";
import useProbateBondRetrieve from "./hooks/useProbateBondRetrieve";
import { BOND_RETRIEVE_PAGE_SECTIONS } from "./bondRetrievePageSections";
import { BondRetrievalShell } from "./components/bondRetrieval/BondRetrievalShell";
import {
  formatCorrectionFieldLabel,
  formatCorrectionFromTo,
} from "./components/ProbateBondFormShared";

const VermostProbateBondRetrieveForm = () => {
  const hookState = useProbateBondRetrieve();
  const sectionConfig = BOND_RETRIEVE_PAGE_SECTIONS.probate;
  const pageCtx = {
    globalState: hookState.globalState,
    updateGlobalState: hookState.updateGlobalState,
    role: hookState.role,
    disabled: hookState.disabled,
    data: hookState.data,
    userdetails: hookState.userdetails,
    bond_id: hookState.bond_id,
  };

  return (
    <BondRetrievalShell
      kind="probate"
      sectionConfig={sectionConfig}
      pageCtx={pageCtx}
      onSubmitDataCorrection={hookState.handleSubmitDataCorrection}
      formatCorrectionFieldLabel={formatCorrectionFieldLabel}
      formatCorrectionFromTo={formatCorrectionFromTo}
      {...hookState}
    />
  );
};

export default VermostProbateBondRetrieveForm;
